import { getTheBoolean, select } from './utils'

const getHomeowner = state => state.homeowner
const selectFromHomeowner = select(getHomeowner)

export const selectDmSuccess = selectFromHomeowner(getTheBoolean('directMessageSuccess'))

export const selectDmFailure = selectFromHomeowner(getTheBoolean('directMessageFailure'))

export const selectDmRequest = selectFromHomeowner(getTheBoolean('directMessageRequest'))
